import { request } from './catalog';

/**
 * The favicon loaded in the admin panel replaces the built-in one (a `data:` picture of index.html)
 * once the server says there is one. Without a server (a local build) nothing changes.
 */
export async function applyFavicon(): Promise<void> {
  try {
    const { res, base } = await request('/api/v1/favicon');
    if (!res.ok) return;
    const info = (await res.json()) as { custom?: boolean; version?: number; svg?: boolean };
    if (!info.custom) return;
    const url = (name: string) => `${base}/api/v1/favicon/${name}?v=${info.version ?? 0}`;
    for (const old of document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]')) old.remove();
    const add = (rel: string, href: string, extra: Record<string, string> = {}) => {
      const l = document.createElement('link');
      l.rel = rel;
      l.href = href;
      for (const [k, v] of Object.entries(extra)) l.setAttribute(k, v);
      document.head.append(l);
    };
    if (info.svg) add('icon', url('svg'), { type: 'image/svg+xml' });
    add('icon', url('32'), { type: 'image/png', sizes: '32x32' });
    add('apple-touch-icon', url('180'));
  } catch {
    /* offline or no server: the built-in icon stays */
  }
}
